import apiClient from 'ps-components/lib/apiClient';
import addAlert from 'ps-components/AlertToast/addAlert';

export const GET_DATA_CUT_SURVEYS_START = 'GET_DATA_CUT_SURVEYS_START';
export const GET_DATA_CUT_SURVEYS_SUCCESS = 'GET_DATA_CUT_SURVEYS_SUCCESS';
export const GET_DATA_CUT_SURVEYS_ERROR = 'GET_DATA_CUT_SURVEYS_ERROR';
export const SEND_DATA_CUT_SUBMISSION_EMAIL_START = 'SEND_DATA_CUT_SUBMISSION_EMAIL_START';
export const SEND_DATA_CUT_SUBMISSION_EMAIL_SUCCESS = 'SEND_DATA_CUT_SUBMISSION_EMAIL_SUCCESS';
export const SEND_DATA_CUT_SUBMISSION_EMAIL_FAILED = 'SEND_DATA_CUT_SUBMISSION_EMAIL_FAILED';
export const UPDATE_EXCEPTION_DECISION_START = 'UPDATE_EXCEPTION_DECISION_START';
export const UPDATE_EXCEPTION_DECISION_SUCCESS = 'UPDATE_EXCEPTION_DECISION_SUCCESS';
export const UPDATE_EXCEPTION_DECISION_ERROR = 'UPDATE_EXCEPTION_DECISION_ERROR';
export const GET_MIGRATION_DETAILS_START = 'GET_MIGRATION_DETAILS_START';
export const GET_MIGRATION_DETAILS_SUCCESS = 'GET_MIGRATION_DETAILS_SUCCESS';
export const GET_MIGRATION_DETAILS_ERROR = 'GET_MIGRATION_DETAILS_ERROR';
export const GET_DATA_CUT_DROPDOWN_SUCCESS = 'GET_DATA_CUT_DROPDOWN_SUCCESS';
export const GET_DATA_CUT_DROPDOWN_ERROR = 'GET_DATA_CUT_DROPDOWN_ERROR ';
export const SET_FILTER_DROPDOWN = 'SET_FILTER_DROPDOWN';
export const SET_LANDING_SEARCH = 'SET_LANDING_SEARCH';

export function getDataCutSurveys(curSurveyYear, newSurveyYear, search, sortField, sortDirection) {
  return async dispatch => {
    dispatch({ type: GET_DATA_CUT_SURVEYS_START });
    try {
      const result = await apiClient.apiPost('/api/migration/selected-surveys/retrieveSelectedSurveys', {
        curSurveyYear: curSurveyYear.toString(),
        newSurveyYear: newSurveyYear.toString(),
        search,
        sortField,
        sortDesc: sortDirection
      });

      const uniqueSurveys = [
        ...result.data.result.reduce((map, survey) => map.set(survey.curSurveyCode, survey), new Map()).values()
      ];
      const exceptionOnlySurveys = uniqueSurveys.filter(survey => survey.dataCutOnlyExceptions);
      const noExceptionSurveys = uniqueSurveys.filter(survey => survey.dataCutOnlyExceptions === 0);

      dispatch({
        type: GET_DATA_CUT_SURVEYS_SUCCESS,
        dataCutSurveys: uniqueSurveys,
        exceptionOnlySurveys,
        noExceptionSurveys,
        totalCount: result.data.totalCount,
        totalDataCutOnlyExceptions: result.data.totalDataCutOnlyExceptions,
        totalDataCutsWithDataCutOnlyExceptions: result.data.totalDataCutsWithDataCutOnlyExceptions
      });
    } catch (error) {
      dispatch({ type: GET_DATA_CUT_SURVEYS_ERROR });
    }
  };
}

export function sendDataCutMigrationSubmissionEmail() {
  return async dispatch => {
    dispatch({ type: SEND_DATA_CUT_SUBMISSION_EMAIL_START });
    try {
      await apiClient.apiPost('/api/migration/selected-surveys/sendMigrationSubmissionEmail');
      dispatch({ type: SEND_DATA_CUT_SUBMISSION_EMAIL_SUCCESS });
      addAlert('Data cut changes have been submitted', 'success');
    } catch (error) {
      dispatch({ type: SEND_DATA_CUT_SUBMISSION_EMAIL_FAILED });
      addAlert('An error occurred when trying to submit data cut changes', 'danger');
    }
  };
}

export function setFilterDropdown(dropdownFilter) {
  return {
    type: SET_FILTER_DROPDOWN,
    dropdownFilter
  };
}

export function updateExceptionDecision(migrations, selectedSurveys) {
  const successMessage = `Decisions for exceptions have been updated for ${selectedSurveys.length || 1} survey(s).`;
  const errorMessage = 'There is an error occured when updating the decisions. Please try again.';
  return async dispatch => {
    dispatch({ type: UPDATE_EXCEPTION_DECISION_START });
    try {
      const result = await apiClient.apiPost('/api/migration/selected-surveys/updateMigrations', {
        migrations
      });
      dispatch({ type: UPDATE_EXCEPTION_DECISION_SUCCESS });
      addAlert(successMessage, 'success');
    } catch (error) {
      dispatch({ type: UPDATE_EXCEPTION_DECISION_ERROR });
      addAlert(errorMessage, 'danger');
    }
  };
}

export function updateDataCutOptions(migrationId, dataCut, firstChoice, secondChoice, thirdChoice) {
  const successMessage = 'Updated data cut options successfully.';
  const errorMessage = 'There was an error updating the selected data cut options. Please try again.';
  return async dispatch => {
    try {
      const result = await apiClient.apiPost('/api/migration/selected-surveys/updateDataCutOptions', {
        migrationId,
        dataCut,
        firstChoice,
        secondChoice,
        thirdChoice
      });
      addAlert(successMessage, 'success');
    } catch (error) {
      addAlert(errorMessage, 'danger');
    }
  };
}

export function selectDataCutDropdown(newSurveyCode) {
  const errorMessage = 'There was an error retrieving data cuts. Please try again.';
  return async dispatch => {
    try {
      const result = await apiClient.apiPost('/api/elasticsearch/data-cuts/search', {
        include: { survey_code: [newSurveyCode], currency: '%' },
        survey_code: [newSurveyCode],
        currency: '%',
        exclude: {},
        es_query: ''
      });
      dispatch({
        type: GET_DATA_CUT_DROPDOWN_SUCCESS,
        dataCutOptions: result.data.data
      });
    } catch (error) {
      dispatch({ type: GET_DATA_CUT_DROPDOWN_ERROR });
      addAlert(errorMessage, 'danger');
    }
  };
}

export function resetDataCutMigrationErrors() {
  return {
    type: RESET_DATA_CUT_ERRORS
  };
}

export function resetExceptionDecisionSuccess() {
  return {
    type: RESET_EXCEPTION_DECISION_SUCCESS
  };
}

export function getMigrationDetails(migrationId, searchText) {
  return async dispatch => {
    dispatch({ type: GET_MIGRATION_DETAILS_START });
    try {
      const result = await apiClient.apiPost('/api/migration/selected-surveys/dataCuts', {
        migrationId,
        searchText
      });
      dispatch({
        type: GET_MIGRATION_DETAILS_SUCCESS,
        migrationDetails: result.data.dataCuts
      });
    } catch (error) {
      dispatch({ type: GET_MIGRATION_DETAILS_ERROR });
    }
  };
}

export async function processDataCutOptions(migrationId, dataCut) {
  const errorMessage = 'There was an error processing data cuts options. Please try again.';
  try {
    await apiClient.apiPost('/api/migration/selected-surveys/processDataCutOptions', {
      migrationId,
      dataCut
    });
  } catch (error) {
    addAlert(errorMessage, 'danger');
  }
}

export function setLandingSearch(searchText) {
  return {
    type: SET_LANDING_SEARCH,
    migrationLandingSearch: searchText
  };
}
